import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import * as actions from "../../../../../app/actions/generalActions";
import { useSpecificationsUIContext } from "./SpecificationsUIContext";
import { useFilterObjectsUIContext } from "../pages/FilterObjectsUIContext";
import { useIntl } from "react-intl";
import { Field } from "formik";

export function SpecificationRecoverDeleteDialog({ reduxName, api, softDelete }) {
  const specsUIContext = useSpecificationsUIContext();
  const filterUIContext = useFilterObjectsUIContext();
  const specsUIProps = useMemo(() => {
    return {
      id: specsUIContext.selectedId,
      parentId: specsUIContext.parentId,
      parentName: specsUIContext.parentName,
      thirdParentId: specsUIContext.thirdParentId,
      thirdParentName: specsUIContext.thirdParentName,
      show: specsUIContext.showRecoverDeleteSpecificationDialog,
      onHide: specsUIContext.closeRecoverDeleteSpecificationDialog,
      queryParams: filterUIContext.queryParams,
      setIds: specsUIContext.setIds,
    };
  }, [specsUIContext, filterUIContext]);

  const dispatch = useDispatch();
  const { isLoading, name } = useSelector(
    (state) => ({
      isLoading: state[reduxName].actionsLoading,
      name: state[reduxName].name,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!specsUIProps.id) {
      specsUIProps.onHide();
    }

  }, [specsUIProps.id]);

  useEffect(() => { }, [isLoading, dispatch]);

  const deleteSpecification = () => {
    var ids = []
    ids.push(specsUIProps.id)
    dispatch(actions.updateObjectsStatus(api, name, ids, false)).then(() => {
      dispatch(
        actions.fetchObjectsByParentId(
          api,
          name,
          specsUIProps.queryParams,
          specsUIProps.parentId,
          specsUIProps.parentName,
        )
      );
      specsUIProps.setIds([]);
      specsUIProps.onHide();

    });
  };

  const intl = useIntl();


  return (
    <Modal
      show={specsUIProps.show}
      onHide={specsUIProps.onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          فعالسازی
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="form">
        {!isLoading && (
          <span>آیا از فعالسازی این رکورد اطمینان دارید؟</span>
        )}
        {isLoading && <span>در حال فعالسازی...</span>}

      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={specsUIProps.onHide}
            className="btn btn-light btn-elevate"
          >
            انصراف
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSpecification}
            className="btn btn-primary btn-elevate"
          >
            فعالسازی
          </button>

        </div>
      </Modal.Footer>
    </Modal>
  );
}
